import { Avatar, Button, Card, CardActionArea, CardActions, CardContent, Container, Grid, Link, List, ListItem, ListItemAvatar, ListItemText, Typography, makeStyles, useTheme } from '@material-ui/core';
import { PageHeader } from 'pages/CustomerBookingCreate/components/PageHeader';
import { STEP_RECIPIENT } from 'pages/CustomerBookingCreate/constants';
import { stepState } from 'pages/CustomerBookingCreate/state';
import imgZennyaLogoWhite from 'assets/zennya-health-logo-clear.png'
import imgAdvertMain from 'assets/advertImg.png'

import React, { useEffect, useMemo, useState } from 'react';
import { useRecoilState } from 'recoil';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Check } from '@material-ui/icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { useHistory } from 'react-router-dom';
import ReactJson from 'react-json-view';
import { useBranch } from '@zennya/web-component-library/src';
import { useTrackEvent } from 'util/trackEvent';

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(.5),
    }
  },
  zennyaLogo: {
    width: 'auto',
    maxHeight: 100,

  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
    }
  },
  imgAdvertMain: {
    width: '100%',
    height: 'auto',
  },
  imgAdvertContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
    }
  },
  duoToneCheckCircle: {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.secondary.light,
  }

}));
const DuoToneCheckCircle = () => {
  const classes = useStyles()
  const theme = useTheme()
  return (
    <Avatar className={classes.duoToneCheckCircle}>
      <FontAwesomeIcon icon={faCircleCheck} color={theme.palette.secondary.dark} />
    </Avatar>
  )
}

const AdvertScreen = ({ }) => {
  const classes = useStyles()
  const [step, setStep] = useRecoilState(stepState);
  const history = useHistory()
  const trackEvent = useTrackEvent()


  const BRANCH_API_KEY = process.env.REACT_APP_BRANCH_API_KEY

  const { branchStatus, getBranchIdentity, deepLink, generateDeeplink } = useBranch({
    apiKey: BRANCH_API_KEY,
  })

  useEffect(
    () => {
      generateDeeplink()
    }, []
  );
  const featureList = [
    <Typography variant="body2"><b>Online consult</b> with a Doctor</Typography>,
    <Typography variant="body2">Medical & Wellness <b>services delivered</b></Typography>,
    <Typography variant="body2"><b>Group</b> bookings</Typography>,
    <Typography variant="body2">End to End <b>Healthcare</b></Typography>,
    <Typography variant="body2">Medical-grade <b>Massages</b></Typography>,
    <Typography variant="body2">Book <b>on demand</b> or <b>schedule for later</b></Typography>,
    <Typography variant="body2">Access your <b>results</b></Typography>,
    <Typography variant="body2">Complete <b>medical records</b></Typography>,
  ]
  return (
    <>
      <PageHeader
        backStep={STEP_RECIPIENT}
        currentStep={null}
        title={"Download zennya Health Mobile App"}
        loading={false}
        showBreadcrumbs={false}
        subheader=''
        onBackStep={() => {
          history.replace(STEP_RECIPIENT)
        }}
      >
        <Card className={classes.card}
        >
          <CardContent>
            <div className={classes.logoContainer}>
              <img src={imgZennyaLogoWhite}
                className={classes.zennyaLogo}
              />
            </div>
          </CardContent>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} md={6}>
                <List dense>
                  {featureList.map((item, index) => {
                    return (
                      <ListItem key={index}>

                        <DuoToneCheckCircle />
                        <ListItemText primary={item} />
                      </ListItem>
                    )
                  })}
                </List>
              </Grid>
              <Grid item xs={12} md={6} style={{ display: 'flex' }}>
                <div className={classes.imgAdvertContainer}>
                  <img src={imgAdvertMain}
                    className={classes.imgAdvertMain}
                  />
                </div>
              </Grid>
            </Grid>
          </CardContent>
          <CardActions>

            <Button
              onClick={()=>{
                trackEvent('Advert - open deeplink', {deepLink})
                window.open(deepLink, '_blank')
              }}
              variant='contained'
              color='primary'
              size='large'
              fullWidth
            >
              Go to the App
            </Button>

          </CardActions>
        </Card>

      </PageHeader>

    </>
  )
}

export { AdvertScreen }